module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "baseinfo"
  }, [_c('mt-header', {
    staticClass: "fixedtop",
    attrs: {
      "title": _vm.title
    }
  }, [_c('mt-button', {
    attrs: {
      "slot": "left",
      "icon": "back"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$router.push("/certification")
      }
    },
    slot: "left"
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "infobody"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "photo"
  }, [_vm._m(1), _vm._v(" "), (_vm.portraitYrl) ? _c('img', {
    staticStyle: {
      "width": "100px",
      "height": "100px"
    },
    attrs: {
      "src": _vm.portraitYrl,
      "alt": ""
    },
    on: {
      "click": _vm.upPortraitBtn
    }
  }) : _c('div', {
    staticClass: "addImg",
    on: {
      "click": _vm.upPortraitBtn
    }
  }, [_c('van-icon', {
    attrs: {
      "name": "plus"
    }
  }), _vm._v(" "), _c('p', [_vm._v("点击上传")])], 1), _vm._v(" "), _c('input', {
    ref: "upPortrait",
    attrs: {
      "id": "upDataPart",
      "type": "file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        return _vm.portraitChange($event)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "dataGroup"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "dataGroupdiv",
    staticStyle: {
      "display": "flex",
      "justify-content": "flex-end",
      "align-items": "center"
    }
  }, [_c('van-field', {
    staticStyle: {
      "border": "0"
    },
    attrs: {
      "readonly": "",
      "clickable": "",
      "placeholder": "",
      "input-align": "right"
    },
    on: {
      "click": _vm.typeShow
    },
    model: {
      value: (_vm.form.enterType),
      callback: function($$v) {
        _vm.$set(_vm.form, "enterType", $$v)
      },
      expression: "form.enterType"
    }
  }), _vm._v(" "), _c('van-icon', {
    attrs: {
      "name": "arrow"
    },
    on: {
      "click": _vm.typeShow
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "dataGroup"
  }, [_vm._m(3), _vm._v(" "), _c('van-field', {
    attrs: {
      "placeholder": "输入您的职位",
      "maxlength": "15"
    },
    model: {
      value: (_vm.form.position),
      callback: function($$v) {
        _vm.$set(_vm.form, "position", $$v)
      },
      expression: "form.position"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "dataGroup"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "flex-end",
      "align-items": "center",
      "width": "70%"
    }
  }, [_c('div', _vm._l((_vm.selectposition), function(item, index) {
    return _c('p', {
      key: index,
      staticClass: "positionname"
    }, [_vm._v("\n                            " + _vm._s(item.name) + "\n                            "), _c('van-icon', {
      attrs: {
        "name": "cross"
      },
      on: {
        "click": function($event) {
          return _vm.delposition(item)
        }
      }
    })], 1)
  }), 0), _vm._v(" "), _c('van-icon', {
    attrs: {
      "name": "arrow"
    },
    on: {
      "click": _vm.positionShow
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "dataGroup"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "dataGroupdiv",
    staticStyle: {
      "display": "flex",
      "justify-content": "flex-end",
      "align-items": "center"
    }
  }, [_c('van-field', {
    attrs: {
      "readonly": "",
      "clickable": "",
      "placeholder": "",
      "input-align": "right"
    },
    on: {
      "click": _vm.workShow
    },
    model: {
      value: (_vm.form.experience),
      callback: function($$v) {
        _vm.$set(_vm.form, "experience", $$v)
      },
      expression: "form.experience"
    }
  }), _vm._v(" "), _c('van-icon', {
    attrs: {
      "name": "arrow"
    },
    on: {
      "click": _vm.workShow
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "dataGroup"
  }, [_vm._m(6), _vm._v(" "), _c('van-field', {
    attrs: {
      "placeholder": "8小时日薪",
      "type": "digit",
      "pattern": "[0-9]*",
      "maxlength": "5"
    },
    model: {
      value: (_vm.form.salary),
      callback: function($$v) {
        _vm.$set(_vm.form, "salary", $$v)
      },
      expression: "form.salary"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "dataGroup"
  }, [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "dataGroupdiv",
    staticStyle: {
      "display": "flex",
      "justify-content": "flex-end",
      "align-items": "center"
    }
  }, [_c('van-field', {
    attrs: {
      "readonly": "",
      "clickable": "",
      "placeholder": "",
      "input-align": "right"
    },
    on: {
      "click": _vm.cityShow
    },
    model: {
      value: (_vm.form.city),
      callback: function($$v) {
        _vm.$set(_vm.form, "city", $$v)
      },
      expression: "form.city"
    }
  }), _vm._v(" "), _c('van-icon', {
    attrs: {
      "name": "arrow"
    },
    on: {
      "click": _vm.cityShow
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "dataGroup"
  }, [_vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "dataGroupdiv",
    staticStyle: {
      "display": "flex",
      "justify-content": "flex-end",
      "align-items": "center"
    }
  }, [_c('van-field', {
    attrs: {
      "readonly": "",
      "clickable": "",
      "placeholder": "",
      "input-align": "right"
    },
    on: {
      "click": _vm.sexShow
    },
    model: {
      value: (_vm.form.sex),
      callback: function($$v) {
        _vm.$set(_vm.form, "sex", $$v)
      },
      expression: "form.sex"
    }
  }), _vm._v(" "), _c('van-icon', {
    attrs: {
      "name": "arrow"
    },
    on: {
      "click": _vm.sexShow
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "57px"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "next"
  }, [_c('van-button', {
    attrs: {
      "type": "info"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("下一步")])], 1)]), _vm._v(" "), _c('van-popup', {
    attrs: {
      "position": "bottom"
    },
    model: {
      value: (_vm.pickType),
      callback: function($$v) {
        _vm.pickType = $$v
      },
      expression: "pickType"
    }
  }, [_c('van-picker', {
    attrs: {
      "show-toolbar": "",
      "columns": _vm.intype
    },
    on: {
      "confirm": _vm.onintypeConfirm,
      "cancel": function($event) {
        _vm.pickType = false
      }
    }
  })], 1), _vm._v(" "), _c('van-popup', {
    attrs: {
      "position": "bottom"
    },
    model: {
      value: (_vm.pickWork),
      callback: function($$v) {
        _vm.pickWork = $$v
      },
      expression: "pickWork"
    }
  }, [_c('van-picker', {
    attrs: {
      "show-toolbar": "",
      "columns": _vm.worktype
    },
    on: {
      "confirm": _vm.onworkConfirm,
      "cancel": function($event) {
        _vm.pickWork = false
      }
    }
  })], 1), _vm._v(" "), _c('van-popup', {
    attrs: {
      "position": "bottom"
    },
    model: {
      value: (_vm.pickcity),
      callback: function($$v) {
        _vm.pickcity = $$v
      },
      expression: "pickcity"
    }
  }, [_c('van-picker', {
    attrs: {
      "show-toolbar": "",
      "columns": _vm.citytype
    },
    on: {
      "confirm": _vm.oncityConfirm,
      "cancel": function($event) {
        _vm.pickcity = false
      }
    }
  })], 1), _vm._v(" "), _c('van-popup', {
    attrs: {
      "position": "bottom"
    },
    model: {
      value: (_vm.picksex),
      callback: function($$v) {
        _vm.picksex = $$v
      },
      expression: "picksex"
    }
  }, [_c('van-picker', {
    attrs: {
      "show-toolbar": "",
      "columns": _vm.sextype
    },
    on: {
      "confirm": _vm.onsexConfirm,
      "cancel": function($event) {
        _vm.picksex = false
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.portraitShow),
      expression: "portraitShow"
    }],
    staticClass: "cut"
  }, [_c('div', {
    staticClass: "cutBtn"
  }, [_c('mt-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.configPart()
      }
    }
  }, [_vm._v("完成")]), _vm._v(" "), _c('mt-button', {
    attrs: {
      "type": "default",
      "size": "small"
    },
    on: {
      "click": function($event) {
        return _vm.canclePart()
      }
    }
  }, [_vm._v("取消")])], 1), _vm._v(" "), _c('vueCropper', {
    ref: "cropper",
    attrs: {
      "img": _vm.portraitUrl,
      "autoCropWidth": _vm.option.autoCropWidth,
      "autoCropHeight": _vm.option.autoCropHeight,
      "autoCrop": true,
      "fixedBox": true,
      "fixed": _vm.option.fixed,
      "fixedNumber": _vm.option.fixedNumber,
      "outputSize": 0.8
    }
  })], 1), _vm._v(" "), _c('van-popup', {
    attrs: {
      "position": "bottom"
    },
    model: {
      value: (_vm.pickposition),
      callback: function($$v) {
        _vm.pickposition = $$v
      },
      expression: "pickposition"
    }
  }, [_c('mt-header', {
    attrs: {
      "title": "选择职位类型"
    }
  }, [_c('van-icon', {
    attrs: {
      "slot": "right",
      "name": "cross"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.onClose($event)
      }
    },
    slot: "right"
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "skilldiv"
  }, _vm._l((_vm.positionArr), function(item, index) {
    return _c('div', {
      key: index
    }, [_c('p', [_vm._v(_vm._s(item.value))]), _vm._v(" "), _c('ul', {
      staticClass: "label_val"
    }, _vm._l((item.children), function(itemchildren, index) {
      return _c('li', {
        key: index,
        ref: "skillsName",
        refInFor: true,
        class: {
          select: itemchildren.active === '1'
        },
        on: {
          "click": function($event) {
            return _vm.toggle(itemchildren)
          }
        }
      }, [_c('span', [_vm._v(_vm._s(itemchildren.name))])])
    }), 0)])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "btn"
  }, [_c('van-button', {
    attrs: {
      "type": "info"
    },
    on: {
      "click": _vm.saveposition
    }
  }, [_vm._v("保存")])], 1)], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "titlebox",
    staticStyle: {
      "padding": "10px 20px"
    }
  }, [_c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('h1', [_vm._v("基本信息")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("头像"), _c('span', {
    staticStyle: {
      "color": "red",
      "font-weight": "bold"
    }
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("选择入驻类型"), _c('span', {
    staticStyle: {
      "color": "red",
      "font-weight": "bold"
    }
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("职位头衔"), _c('span', {
    staticStyle: {
      "color": "red",
      "font-weight": "bold"
    }
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("职位类型"), _c('span', {
    staticStyle: {
      "color": "red",
      "font-weight": "bold"
    }
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("工作经验"), _c('span', {
    staticStyle: {
      "color": "red",
      "font-weight": "bold"
    }
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("日薪"), _c('span', {
    staticStyle: {
      "color": "red",
      "font-weight": "bold"
    }
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("所在城市"), _c('span', {
    staticStyle: {
      "color": "red",
      "font-weight": "bold"
    }
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("性别"), _c('span', {
    staticStyle: {
      "color": "red",
      "font-weight": "bold"
    }
  }, [_vm._v("*")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-69b58e8a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/my/baseinfo.vue
// module id = 1284
// module chunks = 1